		<h3 id="header" class="ui primary header">
			{{ modal.context.title }}
			<i class="link times icon" (click)="modal.deny(undefined)"></i>
		</h3>
 <div class="content" >
       <div class="scroll-wrapper ui basic segment" [ngClass]="{'loading':pending}">
      <div *ngIf="success || error" tamsyMargin marginY="10px">
        <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
        <esl-message-toast [(message)]="error"></esl-message-toast>
      </div>
         <!--Project information -->

         <div class="ui vertical basic segment" fxLayout="column" fxLayoutGap="35px">
            <div fxLayout="row" fxLayoutAlign="start center " fxLayoutGap="25px">
                  <div fxFlex="10%">
                  <img src="assets/avatar/1.jpg" class="ui circular small image"/>
                  </div>
                  <div fxFlex="grow">
                        <h4 class="ui grey header">Encentral Solutions Limited</h4>
                        <button class="ui small primary button" id="rounded" >873663</button>
                  </div>
            </div>
            <div fxLayout="column">
                  <div fxFlex><strong>ADDRESS</strong></div>
                  <div fxFlex>Request to buy 15 pieces of HP Deskjet printers to facilitate the printing jobs in Public Affairs Department.</div>
            </div>

            <div fxLayout="column" >
                  <div fxFlex class="header"><strong>MAIN CONTACT</strong></div>
                  <div fxFlex>Completion of equipment testing centre</div>
            </div>

            <div fxLayout="column" >
                  <div fxFlex><strong >PHONE NUMBER</strong></div>
                  <div fxFlex>Items</div>
            </div>

            <div fxLayout="column" >
                  <div fxFlex><strong>EMAIL ADDRESS</strong></div>
                  <div fxFlex>Random Selections</div>
            </div>
            <div fxLayout="column" >
                  <div fxFlex><strong>DATE ADDED</strong></div>
                  <div fxFlex>5069876354</div>
            </div>

            <div fxLayout="row" >
                  <div fxFlex>
                       <div> IRR STATUS</div>
                        <label class="ui circular grey label">Verified</label>
                  </div>
                      <div fxFlex>
                          <div>BPP VERIFIED</div>
                        <label class="ui circular grey label">True</label>
                  </div>

            </div>
            <div fxLayout="column" >
                  <div fxFlex><strong>OTHER COMPLIANCE </strong></div>
                  <div fxFlex >
                        <label class="ui teal circular label">FIRS</label>
                        <label class="ui teal circular label">ITF</label>
                        <label class="ui teal circular label">NSITF</label>
                        <label class="ui orange circular label">PENCOM</label>
                  </div>
            </div>


      </div>
       </div>
 </div>
      <div  class="actions">

       <button class="ui  primary button" [ngClass]="{'yellow':pending}" [disabled]="pending" (click)="modal.deny(undefined)" autofocus>Close</button>
         <button class="ui  basic primary link button" [ngClass]="{'yellow':pending}" [disabled]="pending" (click)="modal.deny(undefined)" autofocus>View Full Profile</button>
      </div>


